import React from "react";

import classes from "./Header.module.css";
import logo from "../images/MCM_logo_HQ.png";
import interactiveLogo from "../images/logo_interactive_2.png";

const Header = () => {
  return (
    <header className={classes.header}>
      <img className={classes.logo} src={logo} alt="Miami Children's Museum" />
      <img
        className={classes.interactiveLogo}
        src={interactiveLogo}
        alt="Just Plane Crazy!"
      />
    </header>
  );
};

export default Header;
